<tr>
  <td class="ikon">
    <div class="ikon-kontainer">
      <dokument-format-ikon [mimeinfo]="informasjon().standardformat.mimeinfo"/>
      <div class="tilstandsindikatorer">
      @if(dokumentversjon().skjerming.skjermedeMedlemmerId.length > 0 && !visSkjermingDeaktivert()){
        <mat-icon class="skjermet" (click.stopp)="visSkjerming()" matTooltip="{{'Dokumentet er skjult for {antall} medlemmer'| translate: {antall: dokumentversjon().skjerming.skjermedeMedlemmerId.length} }}">visibility_lock</mat-icon>
      }
      @if(elektroniskSigneringAktivert() && !signatarinformasjon().skalSignere){
        <mat-icon fontSet="lederplan-ikon-signer" class="signering-aktivert mat-icon--lederplan-ikon" [matTooltip]="elektroniskSigneringHjelpetekst()"/>
      }
      </div>
    </div>
  </td>
  <td class="navn">
    @if (erFavorittmarkert()) {
      <mat-icon class="favoritt">star</mat-icon>
    }
    @if (informasjon().infisert) {
      <mat-icon class="infisert" matTooltip="{{'Dokumentet ser ut til å være infisert med virus'|translate}}">warning</mat-icon>
    }
    <span data-testid="filnavn" matTooltip="{{'{navn}, registrert {dato} av {bruker}'|translate: {navn: informasjon().standardnavn, dato:dokumentversjon().registreringsdato|zoneddatetimeSomPlaindate|plaindate, bruker: dokumentversjon().registrertAv?.navn} }}">
      {{ informasjon().standardnavn }}
    </span>
    @if(dokumentversjon().type == dokumentTyper.protokolldokumentISak && moeteProtokolldokumentISakErProtokollFor() != null){
      <a (click.stopp)="gaaTilProtokoll()" class="protokoll-for-møte" matTooltip="{{'Gå til møte protokollen gjelder for'|translate }}" matTooltipPosition="after">
        ({{'Protokoll for møte {nummer}, {dato}'|translate: {nummer: moeteProtokolldokumentISakErProtokollFor()!.nummer, dato: moeteProtokolldokumentISakErProtokollFor()!.dato.start | zoneddatetimeSomPlaindate | plaindate} }})
      </a>
    }
    @if (!dokumentversjon().erLestAv && !visNymerkingDeaktivert()) {
      <span class="er-ulest">{{ 'Ny'|translate }}</span>
    }
    @if (elektroniskSigneringAktivert() && signatarinformasjon().skalSignere) {
      <span (click.stopp)="signer()" class="signer" data-testid="signer" matTooltip="{{'Du har blitt bedt om å signere dette dokumentet, klikk her for å starte signeringsprosessen'|translate}}">
        <mat-icon svgIcon="sf:signer"/>
        {{ 'Signer'|translate }}
      </span>
    }
  </td>
  <td class="antall-versjoner" matTooltip="{{'Antall versjoner'|translate}}" data-testid="antall-versjoner">
    <tittel-verdi [verdi]="dokumentversjon().versjonsnummer.toString()" stil="horisontal--en-linje">
      <tittel>
        <mat-icon fontSet="lederplan-ikon-versjoner" class="mat-icon--lederplan-ikon"/>
      </tittel>
    </tittel-verdi>
  </td>
  <td class="antall-sider" matTooltip="{{'Antall sider'|translate}}" data-testid="antall-sider">
    @if (dokumentversjon().antallSider ?? 0 > 0) {
      <tittel-verdi [verdi]="dokumentversjon().antallSider!.toString()" stil="horisontal--en-linje">
        <tittel>
          <mat-icon fontSet="lederplan-ikon-aapenbok" class="mat-icon--lederplan-ikon"/>
        </tittel>
      </tittel-verdi>
    }
  </td>
  <td [class.ingen-annotasjoner]="dokumentversjon().antallAnnotasjoner==0" class="antall-annotasjoner" matTooltip="{{'Antall annotasjoner'|translate}}" data-testid="antall-annotasjoner">
    @if (dokumentversjon().antallAnnotasjoner > 0) {
      <tittel-verdi [verdi]="dokumentversjon().antallAnnotasjoner.toString()" stil="horisontal--en-linje">
        <tittel>
          <mat-icon fontSet="lederplan-ikon-pencil-marker" class="mat-icon--lederplan-ikon"/>
        </tittel>
        {{ dokumentversjon().antallAnnotasjoner }}
      </tittel-verdi>
    }
  </td>
  <td>
    @if (stoetterInlinevisning()) {
      <button mat-icon-button class="mat-medium-icon-button" (click.stopp)="aapneInline()" matTooltip="{{'Åpne opp i forhåndsvisning'|translate}}" data-testid="åpne-inline">
        <mat-icon fontSet="ion-ios-eye-outline" class="mat-icon--ionic-ikon"/>
      </button>
    }
  </td>
  <td>
    <button mat-icon-button class="mat-medium-icon-button" (click.stopp)="aapneStandardformat()" matTooltip="{{'Åpne opp i ny arkfane'|translate}}" data-testid="åpne-standardformat">
      <mat-icon fontSet="lederplan-ikon-aapneiekstern" class="mat-icon--lederplan-ikon"/>
    </button>
  </td>
  <td class="meny">
    <button mat-icon-button [matMenuTriggerFor]="meny.matMeny()" (click)="$event.stopPropagation()" class="mat-medium-icon-button meny" data-testid="åpne-meny">
      <mat-icon class="material-symbols-fet">more_vert</mat-icon>
    </button>
    <dokument-meny [dokumentversjon]="dokumentversjon()" [signatarinformasjon]="signatarinformasjon()" #meny/>
  </td>
</tr>
@if (viserInline()) {
  <!-- def animasjon på tr da det kun er dette elementet :leave vil bli trigget på, bruker så query i animasjonsdef for å angi dokument-inline-pdfviser som mål for animasjon -->
  <tr class="inline-pdfviser" [@skaler]="{hoeydeEkspandert:dokumentHoeydeEkspandert}" (@skaler.done)="inlineVisningFerdigAnimert($event)">
    <td colspan="8">
      <dokument-inline-pdfviser [dokumentversjon]="dokumentversjon()" visFilnavn=false (vedLukk)="lukkInlineVising()"/>
    </td>
  </tr>
}
